import { config } from "../../config"
import { zip } from "../../helpers/utils"

export const consignas = {
  readOne: ({ id, include_answers = false }) => {
    const base = config.apiUrl + `/consignas/${id}`,
      opt = {}

    const params = zip([include_answers], ["include_answers"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  readAll: ({ from = null, limit = null, match = null, token }) => {
    const base = config.apiUrl + `/consignas`,
      opt = {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    const params = zip([from, limit, match], ["f", "l", "q"])

    let query = params
      .filter((param) => param[0] !== null && param[0] !== "")
      .map((param) => `&${param[1]}=${param[0]}`)
      .join("")

    if (query.length) query = "?" + query.substr(1)

    return { url: base + query, opt }
  },

  create: ({ token, cons }) => {
    const url = config.apiUrl + `/consignas`,
      opt = {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(cons),
      }

    return { url, opt }
  },

  update: ({ token, con_id, con }) => {
    const url = config.apiUrl + `/consignas/${con_id}`,
      opt = {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ ...con }),
      }

    return { url, opt }
  },

  delete: ({ token, con_id }) => {
    const url = config.apiUrl + `/consignas/${con_id}`,
      opt = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }

    return { url, opt }
  },

  add_respuesta: ({ con_id, contenido }) => {
    const url = config.apiUrl + `/consignas/${con_id}/respuestas`,
      opt = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ contenido }),
      }

    return { url, opt }
  },

  respuestas: {
    readOne: ({ con_id, res_id }) => {
      const base = config.apiUrl + `/consignas/${con_id}/respuestas/${res_id}`,
        opt = {}

      return { url: base, opt }
    },

    marcas: {
      create: ({ token, con_id, res_id, marca }) => {
        const base =
            config.apiUrl + `/consignas/${con_id}/respuestas/${res_id}/marcas`,
          opt = {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(marca),
          }

        return { url: base, opt }
      },
            update: ({ token, con_id, res_id, marca_id, marca }) => {
        const base =
            config.apiUrl +
            `/consignas/${con_id}/respuestas/${res_id}/marcas/${marca_id}/update`,
          opt = {
            method: "POST", //deberia ser PUT pero servidores de la fing no aceptan puts.
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(marca),
          }

        return { url: base, opt }
      },
      post: ({ token, con_id, res_id, marca_id }) => {
        const base =
            config.apiUrl +
            `/consignas/${con_id}/respuestas/${res_id}/marcas/${marca_id}`,
          opt = {
            method: "POST",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }

        return { url: base, opt }
      },
    },
  },
}
